export const trainerTexts = {
    pl: {
        header_primary: 'Czarna Inez',
        header_secondary: 'Panel Trenera',
        log_as: 'Jesteś zalogowany/a jako:',
        your_games: 'Twoje gry',
        your_games_end: 'Pokaż zakończone gry',
        your_games_running: 'Pokaż trwające gry',
        your_games_prepared: 'Pokaż przygotowane gry',
        languages: 'Możesz przeglądać tę stronę w następujących językach',
        languages_polish: 'Polski',
        languages_english: 'English',
        languages_update: 'Zmień',
        licenses_left: 'Pozostało licencji: ',
        login_prompt: 'Zaloguj się na swoje konto',
        login_confirm: 'Zaloguj się',
        forgot_pass: 'Nie pamiętasz hasła?',
        click_here: 'Kliknij tutaj!',
        send: 'Wyślij',
        create_game: 'Stwórz nową grę',
        refresh: 'Odśwież',
        logout: 'Wyloguj >',
        enter_new_pass: 'Podaj swoje nowe hasło',
        game_status: 'Status gry:',
        game: 'Gra',
        lang: 'język',
        game_active: 'Aktywna',
        game_end: 'Zakończona',
        game_inactive: 'Nieaktywna',
        links_set: 'Zestaw linków',
        trainer: 'Trener',
        copy: 'Skopiuj!',
        delete_game: 'Usuń grę!',
        find_us: 'Znajdź nas',
    },
    eng: {
        header_primary: 'Black Ines',
        header_secondary: "Trainer's panel",
        log_as: 'You are logged as:',
        your_games: 'Your games:',
        your_games_end: 'Your finished games',
        your_games_running: 'Your running games',
        your_games_prepared: 'Your prepared games',
        languages: 'You can browse this page in the following languages',
        languages_polish: 'Polish',
        languages_english: 'English',
        languages_update: 'Change',
        licenses_left: 'Licenses left: ',
        login_prompt: 'Please login into your account',
        login_confirm: 'Login',
        forgot_pass: 'Forgot your password?',
        click_here: 'Click here!',
        send: 'Send',
        create_game: 'Create game',
        refresh: 'Refresh',
        logout: 'Logout >',
        enter_new_pass: 'Enter new pass',
        game_status: 'Game status:',
        game: 'Game',
        lang: 'Language',
        game_active: 'Active',
        game_end: 'Finished',
        game_inactive: 'Not activated',
        links_set: 'Links set',
        trainer: 'Trainer',
        copy: 'Copy!',
        delete_game: 'Delete game!',
        find_us: 'Find us',
    },
};
